import React from "react";
import "../styles/LandingPage.scss";
import Header from "../../../shared/components/Header";
import HomeSection from "./HomeSection/HomeSection";
import { AboutSection } from "./AboutSection/AboutSection";
import { ServicesSection } from "./ServicesSection/ServicesSection";
import Footer from "../../../shared/components/footer";
import { TestimonialsSection } from "./TestimonialsSection/TestimonialsSection";
import ContactUsSection from "./ContactUsSection/ContactUsSection";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { FAQSection } from "./FaqSection/FaqSection";
import { OffersSection } from "./OffersSection/OffersSection";

const HomePage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const currentLanguage =
    location.pathname.split("/")[1] || i18n.language || "en";

  // Determine if the page is in Arabic
  const isArabic = currentLanguage === "ar";

  // Set the canonical URL based on the current language
  const canonicalUrl = `https://wecarebusiness.ae/${currentLanguage}`;

  return (
    <>
      <Helmet>
        <html lang={currentLanguage} dir={isArabic ? "rtl" : "ltr"} />
        <title>
          {t(
            "meta_title",
            "WeCare Business Center - Your Trusted Partner for Growth"
          )}
        </title>
        <meta
          name="description"
          content={t(
            "meta_description",
            "WeCare Business Center offers all-in-one business solutions, from licensing and visas to banking and beyond. Learn more about our services and start your business today."
          )}
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content={t(
            "og_title",
            "WeCare Business Center - Your Trusted Partner for Growth"
          )}
        />
        <meta
          property="og:description"
          content={t(
            "og_description",
            "WeCare Business Center offers comprehensive solutions to make business setup in the UAE effortless. Learn about our services."
          )}
        />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:image"
          content="https://www.wecarebusiness.ae/images/og-image.jpg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:site_name" content="WeCare Business Center" />
        <link rel="canonical" href={canonicalUrl} />
        <meta name="language" content={currentLanguage} />
        {/* Add alternate language links */}
        <link
          rel="alternate"
          hrefLang="en"
          href="https://www.wecarebusiness.ae/en"
        />
        <link
          rel="alternate"
          hrefLang="ar"
          href="https://www.wecarebusiness.ae/ar"
        />
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "WeCare Business Center",
        "url": "https://www.wecarebusiness.ae/",
        "logo": "https://www.wecarebusiness.ae/images/logo.png",
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+971567729666",
          "contactType": "customer service",
          "areaServed": "AE",
          "availableLanguage": ["English", "Arabic"]
        },
        
      }
    `}

          {/* "sameAs": [
          "https://www.facebook.com/yourpage",
          "https://www.instagram.com/yourpage",
          "https://www.linkedin.com/company/yourpage"
        ] */}
        </script>
      </Helmet>
      <Header />
      <div className="home-page">
        <HomeSection />
        <AboutSection />
        <ServicesSection />
        <OffersSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactUsSection />
      </div>
      <Footer />
    </>
  );
};

export default HomePage;
